




























import { defineComponent, watch } from "@vue/composition-api";
import { getAnnouncements } from "@/api";
import { useRequest } from "@/helpers/hooks/useRequest";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Section from "../../Molecules/Section/index.vue";
import Announcement from "../../Molecules/Announcement/index.vue";
import { useRouter } from "@/router";

export default defineComponent({
  name: "Announcements",
  components: {
    Section,
    Heading,
    Announcement
  },
  setup(_, { emit }) {
    const router = useRouter();
    const [{ data: announcements, loading: announcementLoading }] = useRequest(
      () =>
        getAnnouncements({
          limit: 3,
          announce_type: "news",
          announce_method: "news"
        }),
      {
        immediate: true
      }
    );
    watch(announcementLoading, newValue => {
      emit("changeAnnouncementLoading", newValue);
    });

    const handleClickAnnouncementsMore = () => {
      const announcementsRoute = router.resolve({
        name: "Announcements"
      });
      window.open(announcementsRoute.href, "_blank", "noopener");
    };

    return {
      announcements,
      handleClickAnnouncementsMore
    };
  }
});
